<template>
    <div>
        <div
            class="d-flex align-items-center save-video-header p-2"
            tabindex="0"
            v-if="!toggleSaveBtn"
            @click="handleSaveVideo('saveVideo')"
            @keydown.enter="handleSaveVideo('saveVideo')"
            @keydown.space.prevent="handleSaveVideo('saveVideo')"
            >
            <img
                src="../../../src/app/assets/glyphs/heart.svg"
                alt="save video"
                width="30"/>
            <div class="ml-3 h4 mt-2">
                {{ saveButtonText }}
            </div>
        </div>
        <div
            class="d-flex align-items-center saved-video-header p-2"
            v-else
            tabindex="0">
            <img
                src="../../../src/app/assets/glyphs/bg_heart.svg"
                alt="saved video"
                width="30"
                height="30"
            />
            <div class="h4 ml-3 mt-2">
                {{ savedButtonText }}
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";
export default {
    props: {
        saveEndpoint: {
            type: String,
            required: true,
        },
        getEndpoint: {
            type: String,
            required: true,
        },
        saveButtonText: {
            type: String,
            default: "Save",
        },
        savedButtonText: {
            type: String,
            default: "Saved",
        },
    },
    data() {
        return {
            toggleSaveBtn: false,
            alreadSaved: false,
        };
    },
    mounted() {
        window.addEventListener("globalFunctionTriggered", this.updateComponent);
    },
    beforeUnmount() {
        window.removeEventListener("globalFunctionTriggered", this.updateComponent);
    },
    methods: {
        updateComponent(event) {
            if (event.detail.data !== undefined) {
                this.alreadSaved = event.detail.data;
                this.toggleSaveBtn = event.detail.data;
                console.log("Updated component state:", event.detail.data);
            }
        },
        handleSaveVideo(actionType) {
            const videoElement = document.getElementById("videoItemId");
            const categoryElement = document.getElementById("videoCategoryId");
            if (!videoElement || !categoryElement) {
                console.error("Video ID or Category ID not found.");
                return;
            }
            const videoid = videoElement.Value;
            const videocategoryid = categoryElement.Value;
            axios
                .post(this.saveEndpoint, {
                    videos: [
                        {
                            videoId: videoid,
                            categoryId: videocategoryid,
                        },
                    ],
                    isdelete: actionType === "savedVideo",
                })
                .then((res) => {
                    if (res.data) {
                        this.toggleSaveBtn = true;
                    }
                })
                .catch((err) => {
                    console.error("Error:", err);
                });
        },
    },
};
</script>


// WEBPACK FOOTER //
// demo/pages/components/aha-save-video.vue